{
  "nl": {
    "whats_new": {
      "category": {
        "news": "Nieuws",
        "product": "Productupdate",
        "tip": "Tip"
      },
      "category_plural": {
        "news": "Nieuws",
        "product": "Productupdates",
        "tip": "Tips"
      },
      "earlier": "Eerder",
      "empty_description": "Nieuwe functies, tips en nieuws van Ziggu verschijnen hier.",
      "empty_title": "Nog geen berichten",
      "helpful": "Nuttig",
      "helpful_impersonation": "Dit kan niet tijdens een impersonatie.",
      "helpful_mark": "Markeren als nuttig",
      "helpful_marked": "Je vond dit nuttig",
      "image_open": "Afbeelding {index} van {count} openen",
      "load_failed_description": "Controleer je verbinding en probeer het opnieuw.",
      "load_failed_title": "Berichten konden niet worden geladen",
      "new": "Nieuw",
      "no_matches_description": "Geen berichten voor je zoekopdracht of filters. Wis ze om alles te zien.",
      "no_matches_title": "Geen resultaten",
      "read_more": "Meer lezen",
      "retry": "Opnieuw proberen",
      "search": "Berichten zoeken…",
      "subtitle": "Nieuwe functies, tips en nieuws van het Ziggu-team.",
      "title": "Wat is er nieuw"
    }
  }
}
